module.exports = __webpack_public_path__ + "img/zurich.deac70da.jpg";